<template>
    <div :class="['cz__sidebar', { 'cz__saved': savedAs, 'cz__sidebar--visible': visible }]">
        <div class="cz__sidebar-options">
            <div v-if="groups" class="cz__sidebar-options--scrollable">
                <component-group v-for="group in groups" :key="group.code" :controller="controller" :group="group"></component-group>
            </div>
        </div>
        <div class="cz__actions">
            <div>
                <button class="cz__button" @click="save">{{saving ? 'Saving...' : 'Save'}}</button>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    .cz__sidebar {
        position: absolute;

        right: -300px;
        top: 0;

        width: 300px;
        height: 100%;

        background: #fff;

        &.cz__saved {
            .cz__sidebar-options {
            }

            .cz__actions {
            }
        }

        transition: transform 0.25s cubic-bezier(0.17, 0.67, 0.43, 0.98);

        &.cz__sidebar--visible {
            transform: translate(-300px, 0);
        }

        @media (min-width: 768px) {
            right: 0px;
            width: 400px;

            &.cz__sidebar--visible {
                transform: translate(0, 0);
            }
        }
    }

    .cz__sidebar-options {
        position: absolute;

        left: 0;
        top: 0;
        width: 100%;
        height: ~"calc(100% - 60px)";

        overflow: auto;
        -webkit-overflow-scrolling: touch;

        padding: 10px;

        transition: height 0.2s linear;
    }

    .cz__actions {
        position: absolute;

        display: flex;
        justify-content: left;
        align-items: center;

        left: 0;
        bottom: 0;
        width: 100%;
        height: 60px;

        padding: 10px;

        transition: height 0.2s linear;

        > div {
            width: 100%;
        }

        .cz__button {
            width: 100%;
        }
    }
</style>

<script>
    import ComponentGroup from './ComponentGroup';

    import EventBus from './eventbus';

    export default {
        props: {
            controller: Object,
            visible: Boolean,
        },
        data() {
            return {
                groups: null,
                saving: false,
                savedAs: null,
            };
        },
        watch: {
            controller: {
                handler(newValue, oldValue) {
                    this.ensureOptions(newValue, oldValue);
                },
                deep: false,
            },
        },
        mounted() {
            this.ensureOptions(this.controller, this.controller);
        },
        methods: {
            // Saves the recipe.
            save() {
                this.saving = true;

                this.controller.saveRecipe().then((result) => {
                    this.saving = false;

                    this.savedAs = result.location;

                    EventBus.$emit('addToCart', result);
                });
            },

            ensureOptions(newValue, oldValue) {
                // Create proxy functions to bind 'this' pointers.
                if (!this.onStateChanged) {
                    this.onStateChanged = (state) => { this.stateChanged(state); };
                }

                // Unbind from the old controller.
                if (oldValue) {
                    oldValue.off('stateChanged', this.onStateChanged);
                }

                if (newValue) {
                    // Listen to events on the new controller.
                    newValue.on('stateChanged', this.onStateChanged);

                    // If blueprint is already configured (i.e. we missed initializeBlueprint/State events), force the update.
                    if (newValue.blueprintReady) {
                        this.stateChanged({
                            blueprint: newValue.blueprint,
                            state: newValue.state,
                        });
                    }
                }
            },

            // React to state changes.
            stateChanged(state) {
                this.groupOptions(state.blueprint, state.state);
            },

            // Prepare data by rearranging component options into areas by groups and placements, and then by each option type (e.g. by materials,
            // then by colors, etc).
            groupOptions(blueprint) {
                const groups = [];

                // Group components.
                (blueprint.groups || []).forEach((group) => {
                    const displayGroup = Object.assign({}, group, { placements: [] });

                    (group.placements || []).forEach((placement) => {
                        const definitions = [];

                        (placement.components || []).forEach((component) => {
                            if (!component.description) {
                                return;
                            }

                            (component.description || []).forEach((description) => {
                                // Is there already a group for this option definition?
                                let definition = definitions.find(l => l.description.definition === description.definition);

                                if (!definition) {
                                    definition = {
                                        description,
                                        options: [],
                                    };

                                    definitions.push(definition);
                                }

                                // Aggregate options for each definition.
                                let option = definition.options.find(o => o.option.code === description.code);
                                if (!option) {
                                    option = {
                                        option: (blueprint.options || []).find(o => o.code === description.code),
                                        components: [],
                                    };

                                    definition.options.push(option);
                                }

                                option.components.push({
                                    component,
                                    selected: this.controller.isSelected(component.code),
                                });
                            });
                        });

                        definitions.forEach((d) => {
                            d.options.forEach((o) => {
                                o.selected = o.components.some(c => c.selected);
                            });
                        });

                        displayGroup.placements.push({
                            placement,
                            definitions,
                        });
                    });

                    groups.push(displayGroup);
                });

                this.groups = groups;
            },
        },
        components: {
            ComponentGroup,
        },
    };
</script>